"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import linkMailbox from "./link_mailbox";
import linkMaybeMailbox from "./link_maybe_mailbox";
import linkIntegerMailbox from "./link_integer_mailbox";
export const Form = (model, mailbox) => (...keyPath) => {
  return {
    mailbox,
    model,
    keyPath
  };
};
export const TextInput = (_a) => {
  var _b = _a, { mailbox, model, keyPath } = _b, rest = __objRest(_b, ["mailbox", "model", "keyPath"]);
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadValues({
      type: "text",
      valueLink: linkMailbox(model, mailbox, keyPath)
    }, rest)
  );
};
export const EmailInput = (_c) => {
  var _d = _c, { mailbox, model, keyPath } = _d, rest = __objRest(_d, ["mailbox", "model", "keyPath"]);
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadValues({
      type: "email",
      valueLink: linkMailbox(model, mailbox, keyPath)
    }, rest)
  );
};
export const PasswordInput = (_e) => {
  var _f = _e, { mailbox, model, keyPath } = _f, rest = __objRest(_f, ["mailbox", "model", "keyPath"]);
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadValues({
      type: "password",
      valueLink: linkMailbox(model, mailbox, keyPath)
    }, rest)
  );
};
export const DateInput = (_g) => {
  var _h = _g, { mailbox, model, keyPath } = _h, rest = __objRest(_h, ["mailbox", "model", "keyPath"]);
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadValues({
      type: "date",
      valueLink: linkMailbox(model, mailbox, keyPath)
    }, rest)
  );
};
export const FloatInput = (_i) => {
  var _j = _i, { mailbox, model, keyPath } = _j, rest = __objRest(_j, ["mailbox", "model", "keyPath"]);
  const blur = function(event) {
    const value = parseFloat(event.target.value);
    if (isNaN(value)) {
      mailbox.sendPayload([keyPath, null]);
    } else {
      mailbox.sendPayload([keyPath, value]);
    }
  };
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadValues({
      type: "text",
      valueLink: linkMailbox(model, mailbox, keyPath),
      onBlur: blur
    }, rest)
  );
};
export const IntegerInput = ({ mailbox, model, keyPath }) => {
  const blur = function(event) {
    const value = parseInt(event.target.value, 10);
    if (isNaN(value)) {
      mailbox.sendPayload([keyPath, null]);
    } else {
      mailbox.sendPayload([keyPath, value]);
    }
  };
  return /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      valueLink: linkMailbox(model, mailbox, keyPath),
      onBlur: blur
    }
  );
};
export const Checkbox = (_k) => {
  var _l = _k, { mailbox, model, keyPath } = _l, rest = __objRest(_l, ["mailbox", "model", "keyPath"]);
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadValues({
      type: "checkbox",
      checked: model.getIn(keyPath),
      onChange: () => mailbox.sendPayload([keyPath, !model.getIn(keyPath)])
    }, rest)
  );
};
export const RadioButton = (_m) => {
  var _n = _m, { mailbox, model, keyPath, value } = _n, rest = __objRest(_n, ["mailbox", "model", "keyPath", "value"]);
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadValues({
      type: "radio",
      name: rest.name || keyPath.join("_"),
      value,
      checked: model.getIn(keyPath) === value,
      onChange: () => mailbox.sendPayload([keyPath, value])
    }, rest)
  );
};
export const TextArea = (_o) => {
  var _p = _o, { mailbox, model, keyPath } = _p, rest = __objRest(_p, ["mailbox", "model", "keyPath"]);
  return /* @__PURE__ */ React.createElement(
    "textArea",
    __spreadValues({
      valueLink: linkMailbox(model, mailbox, keyPath)
    }, rest)
  );
};
const optionElements = (options) => {
  const option = (valueLabelPair) => /* @__PURE__ */ React.createElement(
    "option",
    {
      key: valueLabelPair[0] + valueLabelPair[1] + Math.round(Math.random() * 1e6),
      value: valueLabelPair[0]
    },
    valueLabelPair[1]
  );
  return options.map(option);
};
export const SelectString = (_q) => {
  var _r = _q, { mailbox, model, keyPath, options } = _r, rest = __objRest(_r, ["mailbox", "model", "keyPath", "options"]);
  return /* @__PURE__ */ React.createElement(
    "select",
    __spreadValues({
      valueLink: linkMaybeMailbox(model, mailbox, keyPath)
    }, rest),
    optionElements(options)
  );
};
export const SelectInteger = (_s) => {
  var _t = _s, { mailbox, model, keyPath, options } = _t, rest = __objRest(_t, ["mailbox", "model", "keyPath", "options"]);
  return /* @__PURE__ */ React.createElement(
    "select",
    __spreadValues({
      valueLink: linkIntegerMailbox(model, mailbox, keyPath)
    }, rest),
    optionElements(options)
  );
};
Form.TextInput = TextInput;
Form.FloatInput = FloatInput;
Form.IntegerInput = IntegerInput;
Form.Checkbox = Checkbox;
Form.TextArea = TextArea;
Form.SelectString = SelectString;
Form.SelectInteger = SelectInteger;
Form.RadioButton = RadioButton;
Form.PasswordInput = PasswordInput;
Form.EmailInput = EmailInput;
export default Form;
